import React from "react";
import styled, { keyframes } from "styled-components";
import { Transition } from "react-transition-group";

import ImageComponent, { ImageProps, buildUrl } from "../../../common/components/Image";

interface State {
  shown: boolean;
}

class BlurredLazyImage extends React.Component<ImageProps, State> {
  public state: State = {
    shown: false,
  };
  private imageEl?: HTMLImageElement;

  public componentDidMount() {
    this.startLoading(this.props);
  }

  public componentWillReceiveProps(nextProps: ImageProps) {
    if (this.props.image !== nextProps.image) {
      this.setState({
        shown: false,
      });
      this.startLoading(nextProps);
    }
  }

  public componentWillUnmount() {
    if (this.imageEl) {
      this.imageEl.removeEventListener("load", this.onLoad);
    }
  }

  public startLoading = (props: ImageProps) => {
    const { image, size, x2 } = props;
    if (image) {
      const { url } = buildUrl(image.url, size, x2);
      this.imageEl = new Image();
      this.imageEl.addEventListener("load", this.onLoad);
      this.imageEl.setAttribute("src", url);
    }
  };

  public onLoad = () => {
    this.setState({ shown: true });
  };

  public render() {
    const { shown } = this.state;
    return (
      <ImageWrapper>
        <Transition in={!shown} timeout={TRANSITION_DURATION}>
          {(status: string) => {
            if (status === "exited") {
              return null;
            }
            return <LQIPImage {...this.props} size="50x50#b4x4" x2={false} />;
          }}
        </Transition>
        <Transition in={shown} timeout={TRANSITION_DURATION}>
          {(status: string) => {
            if (status === "exited") {
              return null;
            }
            return <MainImage {...this.props} />;
          }}
        </Transition>
      </ImageWrapper>
    );
  }
}

const TRANSITION_DURATION = 180;
const TRANSITION_EASING = "ease-out";

const ImageWrapper = styled.div`
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
`;
const LQIPImage = styled(ImageComponent)`
  z-index: -1;
`;

const ShowImageAnimation = keyframes`
  from {
    opacity: 0;
    transform: scale(1.01);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;
const MainImage = styled(ImageComponent)`
  position: absolute;
  top: 0;
  left: 0;
  animation: ${ShowImageAnimation} ${TRANSITION_DURATION}ms ${TRANSITION_EASING};
`;

export default BlurredLazyImage;



// WEBPACK FOOTER //
// ./frontend/src/common/components/lazy/BlurredLazyImage.tsx